<template>
   <div>
        <div>
            <div class="table-wrapper on-575" v-if="$i18n.locale=='en'">
                <div class="custom-table financial-table ">
                    <div class="trow b-top">
                        <div class="font skyblue">Associate/Joint Venture</div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="trow">
                        <div class="font">IHS Kuwait Limited (note 9)</div>
                        <div class="font end ">Kuwait</div>
                        <div class="th">
                            <div class="finacial-year font"><span class="blackColor bgColor">30%</span><span class="blackColor bgColor">-</span></div>
                        </div>
                    </div>
                    <div class="trow">
                        <div class="font">Zain Al Ajial S.A (Wana Corporate S.A
                            <br /> is an associate of this joint venture)</div>
                        <div class="font end">Morocco</div>
                        <div class="th">
                            <div class="finacial-year font"><span class="blackColor bgColor">50%</span><span class="blackColor bgColor">50%</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div>
            <div class="table-wrapper on-575" v-if="$i18n.locale=='ar'">
                <div class="custom-table financial-table ">
                    <div class="trow b-top">
                        <div class="font skyblue">الشركة الزميلة / المشروع المشترك</div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="trow">
                        <div class="font">شركة آي اتش اس الكويت ليمتد (إيضاح رقم 9)</div>
                        <div class="font end ">الكويت</div>
                        <div class="th">
                            <div class="finacial-year font"><span class="blackColor bgColor">%30</span><span class="blackColor bgColor">-</span></div>
                        </div>
                    </div>
                    <div class="trow">
                        <div class="font">شركة زين الأجيال (شركة وانا إس إيه وهي شركة زميلة لهذا المشروع المشترك)</div>
                        <div class="font end">المغرب</div>
                        <div class="th">
                            <div class="finacial-year font"><span class="blackColor bgColor">%50</span><span class="blackColor bgColor">%50</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>